module.exports = __webpack_public_path__ + "static/headerRightBg-0f4d6b20cc6a13ce638cf5f12acf1202.png";